export default __webpack_public_path__ + "static/media/arrow.b17a8343.svg";